import Settings from './Settings';

export default Settings;



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/index.ts